import './TagManageModal.css';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import TagSelect from './TagSelect';
import { baziAPI } from '../api/api';

/**
 * 命例标签管理弹层（Dashboard 卡「⋯」菜单入口）。
 * 打开时按 id 拉取详情取当前标签名（列表接口未 populate 标签），
 * 保存走 baziAPI.update（传标签名数组，后端自动建缺失标签）。
 */
const TagManageModal = ({ open, record, onClose, onSaved }) => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !record) return;
    let alive = true;
    setError('');
    // 若卡片已带 populate 的标签则直接用，否则拉详情
    const populated = (record.labels || []).every((l) => l && typeof l === 'object' && l.name);
    if (record.labels && record.labels.length > 0 && populated) {
      setTags(record.labels.map((l) => l.name));
      return;
    }
    setLoading(true);
    baziAPI.getById(record._id)
      .then((res) => {
        if (!alive) return;
        const labels = res.data?.data?.labels || [];
        setTags(labels.map((l) => (typeof l === 'object' ? l.name : l)).filter(Boolean));
      })
      .catch(() => alive && setError('加载标签失败'))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [open, record]);

  if (!open || !record) return null;

  const handleSave = async () => {
    try {
      setSaving(true);
      setError('');
      const res = await baziAPI.update(record._id, { labels: tags });
      onSaved && onSaved(res.data?.data);
      onClose && onClose();
    } catch (e) {
      setError('保存失败，请重试');
    } finally {
      setSaving(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="tagmgr-backdrop" onClick={onClose}>
      <div className="tagmgr-dialog" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="tagmgr-head">
          <span>管理标签 · {record.name}</span>
          <button className="tagmgr-close" onClick={onClose} aria-label="关闭"><X size={18} /></button>
        </div>
        <div className="tagmgr-body">
          {loading ? (
            <div className="tagmgr-hint">加载中…</div>
          ) : (
            <TagSelect value={tags} onChange={setTags} placeholder="输入标签，按回车添加" allowFreeText={true} />
          )}
          {error && <div className="tagmgr-error">{error}</div>}
        </div>
        <div className="tagmgr-actions">
          <button className="btn btn-secondary" onClick={onClose}>取消</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving || loading}>
            {saving ? '保存中…' : '保存'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TagManageModal;
